const config = {
  apiBaseUrl: import.meta.env.REACT_APP_API_BASE_URL,
  appName: import.meta.env.REACT_APP_APP_NAME || 'Gently',
  googleMapsApiKey: import.meta.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  isDev: import.meta.env.MODE === 'development',
  outlookClientId: import.meta.env.REACT_APP_OUTLOOK_CLIENT_ID,
  posthogApiKey: import.meta.env.REACT_APP_POSTHOG_API_KEY,
  posthogApiHost: import.meta.env.REACT_APP_POSTHOG_HOST,
  sentryDsn: import.meta.env.REACT_APP_SENTRY_DSN,

  // CSV of pairs: "from1, to1, from2, to2, ..." e.g. "TestCo, Company Name, ChildCo1, Subsidiary1"
  demoCompanyNameReplacements: import.meta.env
    .REACT_APP_DEMO_COMPANY_NAME_REPLACEMENTS,
};

export default config;
